// Copyright (c) StrangeBee 2023

import { PoolDrawer } from '@Molecules/PoolDrawer/PoolDrawer';
import React, { ReactElement } from 'react';
import { CaseInput, CaseOutput, CustomStatusOutput } from 'thehive-sdk';
import CaseStatusManage from '../CaseStatusManage/CaseStatusManage';

interface CaseBulkStatusManageProps {
    poolData: CaseOutput[];
    triggerElem: ReactElement;
    statusList: CustomStatusOutput[];
    onStart?: () => void;
    onFinish?: () => void;
    onEdit: (values: Partial<CaseInput>, id: string) => Promise<void | CaseOutput>;
    onClose: () => void;
    closed?: boolean;
}

export const CaseBulkStatusManage = ({
    poolData,
    triggerElem,
    statusList,
    onStart,
    onFinish,
    onEdit,
    onClose,
    closed = true,
}: CaseBulkStatusManageProps): ReactElement => {
    return poolData.length > 1 ? (
        <PoolDrawer<CaseOutput> poolData={poolData} triggerElem={triggerElem} onStart={onStart} onFinish={onFinish}>
            {({ data, next, isLast, finish }) => (
                <CaseStatusManage
                    data={data}
                    closed={closed}
                    onEdit={(values, id) => {
                        return onEdit(values, id).then(() => {
                            next();
                        });
                    }}
                    caseId={data._id}
                    statusList={statusList}
                    disabledToggleDrawer={!isLast}
                    defaultVisible
                    destroyOnClose={false}
                    onChange={(visibility) => {
                        if (!visibility) {
                            finish();
                            onClose();
                        }
                    }}
                />
            )}
        </PoolDrawer>
    ) : (
        <CaseStatusManage
            triggerElem={triggerElem}
            data={poolData[0]}
            onEdit={onEdit}
            caseId={poolData[0]?._id}
            closed={closed}
            statusList={statusList}
        />
    );
};
